(function () {
  var STORAGE_KEY = "pf_scratch_popup_state_v2";

  function getState() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    } catch (e) {
      return {};
    }
  }

  function setState(next) {
    try {
      var current = getState();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign(current, next)));
    } catch (e) {}
  }

  function init(root) {
    var state = getState();

    if (state.completed) return;

    if (state.dismissedAt) {
      var cooldownDays = parseInt(root.dataset.cooldownDays || "7", 10);
      var elapsedMs = Date.now() - state.dismissedAt;
      if (elapsedMs < cooldownDays * 24 * 60 * 60 * 1000) return;
    }

    var delaySeconds = parseFloat(root.dataset.delaySeconds || "5");
    window.setTimeout(function () {
      showPopup(root);
    }, Math.max(0, delaySeconds) * 1000);
  }

  function showPopup(root) {
    root.classList.add("is-visible");
    window.requestAnimationFrame(function () {
      initScratchCard(root);
    });
    document.addEventListener("keydown", onKeydown);

    function onKeydown(e) {
      if (e.key === "Escape") {
        dismiss(root);
        document.removeEventListener("keydown", onKeydown);
      }
    }
  }

  function dismiss(root) {
    root.classList.remove("is-visible");
    setState({ dismissedAt: Date.now() });
  }

  function goToStep(root, stepName) {
    root.querySelectorAll("[data-scratch-step]").forEach(function (el) {
      el.classList.toggle("is-active", el.dataset.scratchStep === stepName);
    });
  }

  function initScratchCard(root) {
    var canvas = root.querySelector("[data-scratch-canvas]");
    if (!canvas || canvas.dataset.initialized === "true") return;
    canvas.dataset.initialized = "true";

    var ctx = canvas.getContext("2d");
    var wrap = canvas.parentElement;

    function resize() {
      var rect = wrap.getBoundingClientRect();
      var dpr = window.devicePixelRatio || 1;
      canvas.width = Math.round(rect.width * dpr);
      canvas.height = Math.round(rect.height * dpr);
      canvas.style.width = rect.width + "px";
      canvas.style.height = rect.height + "px";
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      paintScratchSurface(rect.width, rect.height);
    }

    function paintScratchSurface(width, height) {
      ctx.globalCompositeOperation = "source-over";

      // Metallic gold-to-ink foil gradient
      var gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, "#E3C25F");
      gradient.addColorStop(0.45, "#C9A227");
      gradient.addColorStop(0.55, "#8A6D1D");
      gradient.addColorStop(1, "#3A3A37");
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);

      // Soft diagonal sheen
      ctx.save();
      ctx.globalAlpha = 0.16;
      ctx.fillStyle = "#FFFFFF";
      ctx.beginPath();
      ctx.moveTo(width * 0.12, 0);
      ctx.lineTo(width * 0.32, 0);
      ctx.lineTo(width * 0.1, height);
      ctx.lineTo(width * -0.1, height);
      ctx.closePath();
      ctx.fill();
      ctx.restore();

      // Large centered "?" watermark
      ctx.fillStyle = "rgba(44, 44, 42, 0.35)";
      ctx.font = "italic 700 " + Math.round(height * 0.6) + "px Georgia, 'Playfair Display', serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText("?", width / 2, height / 2 - height * 0.04);

      // Hint label
      ctx.fillStyle = "rgba(44, 44, 42, 0.78)";
      ctx.font = "700 11px sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "alphabetic";
      ctx.fillText("SCRATCH TO REVEAL", width / 2, height - 14);
    }

    resize();
    window.addEventListener("resize", resize);

    var isPointerDown = false;
    var brushRadius = 24;

    function getPos(evt) {
      var rect = canvas.getBoundingClientRect();
      var point = evt.touches && evt.touches.length ? evt.touches[0] : evt;
      return {
        x: point.clientX - rect.left,
        y: point.clientY - rect.top,
      };
    }

    function scratchAt(pos) {
      ctx.globalCompositeOperation = "destination-out";
      ctx.beginPath();
      ctx.arc(pos.x, pos.y, brushRadius, 0, Math.PI * 2);
      ctx.fill();
    }

    var lastCheck = 0;
    function maybeCheckCompletion() {
      var now = Date.now();
      if (now - lastCheck < 250) return;
      lastCheck = now;

      var imageData;
      try {
        imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      } catch (e) {
        return;
      }
      var transparentCount = 0;
      var totalSamples = 0;
      for (var i = 3; i < imageData.length; i += 4 * 8) {
        totalSamples++;
        if (imageData[i] < 40) transparentCount++;
      }
      var scratchedRatio = totalSamples ? transparentCount / totalSamples : 0;
      if (scratchedRatio > 0.45) {
        revealPrize(root, canvas);
      }
    }

    function pointerDown(evt) {
      isPointerDown = true;
      scratchAt(getPos(evt));
    }
    function pointerMove(evt) {
      if (!isPointerDown) return;
      evt.preventDefault();
      scratchAt(getPos(evt));
      maybeCheckCompletion();
    }
    function pointerUp() {
      isPointerDown = false;
      maybeCheckCompletion();
    }

    canvas.addEventListener("mousedown", pointerDown);
    canvas.addEventListener("mousemove", pointerMove);
    window.addEventListener("mouseup", pointerUp);

    canvas.addEventListener("touchstart", pointerDown, { passive: true });
    canvas.addEventListener("touchmove", pointerMove, { passive: false });
    canvas.addEventListener("touchend", pointerUp);
  }

  function revealPrize(root, canvas) {
    if (canvas.dataset.revealed === "true") return;
    canvas.dataset.revealed = "true";

    canvas.style.transition = "opacity 0.4s ease";
    canvas.style.opacity = "0";
    window.setTimeout(function () {
      canvas.style.display = "none";
    }, 400);

    var claimWrap = root.querySelector("[data-scratch-claim-wrap]");
    if (claimWrap) {
      window.setTimeout(function () {
        claimWrap.classList.add("is-shown");
      }, 250);
    }
  }

  function submitEmail(root, form) {
    var emailInput = form.querySelector('input[name="contact[email]"]');
    var errorEl = root.querySelector("[data-scratch-error]");
    var submitBtn = form.querySelector('button[type="submit"]');
    var email = emailInput.value.trim();

    errorEl.textContent = "";

    if (!email || email.indexOf("@") === -1) {
      errorEl.textContent = "Please enter a valid email address.";
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = "Please wait...";

    var formData = new FormData(form);

    fetch(form.action, {
      method: "POST",
      body: formData,
      headers: { Accept: "text/html" },
    })
      .catch(function () {
      })
      .finally(function () {
        setState({ completed: true, completedAt: Date.now() });
        goToStep(root, "success");
        startCountdown(root);
      });
  }

  function startCountdown(root) {
    var timerEl = root.querySelector("[data-scratch-timer]");
    if (!timerEl || timerEl.dataset.started === "true") return;
    timerEl.dataset.started = "true";

    var seconds = parseInt(root.dataset.countdownSeconds || "59", 10);

    function render() {
      var m = Math.floor(seconds / 60);
      var s = seconds % 60;
      timerEl.textContent = m + ":" + (s < 10 ? "0" : "") + s;
    }

    render();
    var interval = window.setInterval(function () {
      seconds -= 1;
      if (seconds < 0) {
        window.clearInterval(interval);
        return;
      }
      render();
    }, 1000);
  }

  document.addEventListener("DOMContentLoaded", function () {
    var root = document.querySelector("[data-scratch-popup]");
    if (!root) return;

    init(root);

    root.querySelectorAll("[data-scratch-close]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        dismiss(root);
      });
    });

    root.addEventListener("click", function (evt) {
      if (evt.target === root) dismiss(root);
    });

    var claimBtn = root.querySelector("[data-scratch-claim]");
    if (claimBtn) {
      claimBtn.addEventListener("click", function () {
        goToStep(root, "email");
      });
    }

    var form = root.querySelector("[data-scratch-email-form]");
    if (form) {
      form.addEventListener("submit", function (evt) {
        evt.preventDefault();
        submitEmail(root, form);
      });
    }
  });
})();
